module.exports = __webpack_public_path__ + "assets/img/img270.2d2b8ba7.png";